export enum WebSocketMessageActionRequestType {
  BulkDeleteAssets = 'WebsocketActionRequestType_BulkDeleteAssets',
  CreateBulkPrintJob = 'WebsocketActionRequestType_CreateBulkPrintJob',
  GetPreview = 'WebsocketActionRequestType_GetPreview',
  SyncDisplayNameResults = 'WebsocketActionRequestType_SyncDisplayNames',
  SyncSectionSmartFilters = 'WebsocketActionRequestType_SyncSectionSmartFilters',
  SyncSmartDisplayAttributes = 'WebsocketActionRequestType_SyncSmartDisplayAttributes'
}
